import React from 'react';
import { DetailMap } from '../../DetailMap';
import { ZdsDivider } from '@zig-design-system/ui-components-react';
const DetailMapComponent = ({ latitude, longitude }) => {
    const renderMap = () => {
        return (React.createElement("div", { className: "zds-margin-top-4" },
            React.createElement("div", { className: "wide-content" },
                React.createElement(DetailMap, { latitude: latitude, longitude: longitude })),
            React.createElement("div", { className: "default-content" },
                React.createElement(ZdsDivider, { className: "zds-margin-y-4 md:zds-margin-y-8" }))));
    };
    return latitude > 0 && longitude > 0 ? renderMap() : null;
};
export default DetailMapComponent;
